<template>
  <div class="itemSection">
    <v-text-field
      :label="label"
      :value="value"
      :disabled="isDisabled"
      :placeholder="placeholder"
      :rules="rules"
      @change="change"
    ></v-text-field>
    <v-icon class="mb-5" @click="toggleDisable">$sl-edit</v-icon>
  </div>
</template>

<script>

// @group Common
// Styled EnablableTextField component
export default {
  name: "EnablableTextField",

  data: () => ({
    isDisabled: true,
  }),

  props: {
     // Has value
    value: String,
    // Has rules
    rules: Array,
    // Has label
    label: String,
     //has placeholder
    placeholder: String,
    //is disabled
    disabled: {
        // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    }
  },

  created() {
    this.isDisabled = this.disabled;
  },

  methods: {
     /**
     * @vuese
     * Used to watch the disabled , and emit change-state
     * @arg the argument is a boolean 
     */
    toggleDisable() {
      this.isDisabled = !this.isDisabled
      this.$emit('change-state',this.isDisabled)
    },
       /**
   * @vuese
   * Used to watch text field changes an emit a value
   * @arg the argument is a new  date  selected
   */
    change(value) {
      // Fire input with new value
      // @arg valie is an string 
      this.$emit('input', value)
    }
  }

}
</script>

<style lang="scss" scoped>

</style>